import { call, getContext, put, takeEvery } from 'redux-saga/effects';
import BasketAPI from '../../../api/basket/BasketAPI';
import { BasketActionTypes } from '../../../enums/ActionEnums';
import { basketActions } from '../actions/BasketActions.creators';
export function* removeProductFromBasket(action) {
    try {
        const { defaultRequestParams, servicesEndpoint } = yield getContext('aemConfiguration');
        yield put(basketActions.createUpdateItemsErrorStateAction(null));
        yield call(BasketAPI.removeProductFromBasket, action.payload.product, servicesEndpoint, defaultRequestParams);
        yield put(basketActions.createRemoveSuccessAction(action.payload.product, action.type === BasketActionTypes.REMOVE_PRODUCT_AND_UPDATE ? action.payload.tile : undefined));
    }
    catch (_a) { }
}
export function* removeProductFromBasketSaga() {
    yield takeEvery(BasketActionTypes.REMOVE_PRODUCT, removeProductFromBasket);
}
